var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#FFFFFF",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1204 5.32003H17.0004V2.14003C16.0901 2.04538 15.1755 1.99865 14.2604 2.00003C11.5404 2.00003 9.68035 3.66003 9.68035 6.70003V9.32003H6.61035V12.88H9.68035V22H13.3604V12.88H16.4204L16.8804 9.32003H13.3604V7.05003C13.3604 6.00003 13.6404 5.32003 15.1204 5.32003Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.1b866446fec638ef01e2492bfc288c8a.svg";
export { ForwardRef as ReactComponent };